import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X, Home, BarChart3, Settings, LogOut, Users, Building2, TrendingUp } from 'lucide-react';
import './Sidebar.css';

const Sidebar = ({ view, setView, auth, onLogout, allowedViews }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigate = (newView) => {
    setView(newView);
    setIsOpen(false);
  };

  const getMenuItems = () => {
    // Los items se filtran basándose en allowedViews que viene del padre
    const allItems = [
      { view: 'public', label: 'Resultados', icon: Home, color: '#8b5cf6' },
      { view: 'scores', label: 'Puntuaciones', icon: BarChart3, color: '#6f86d6' },
      { view: 'clubs', label: 'Clubes', icon: Building2, color: '#6bd098' },
      { view: 'judges', label: 'Jueces', icon: Users, color: '#fbc658' },
      { view: 'analytics', label: 'Análisis', icon: TrendingUp, color: '#a672d4' },
      { view: 'admin', label: 'Competencias', icon: Settings, color: '#ef8157' }
    ];
    
    return allItems.filter(item => allowedViews?.includes(item.view));
  };
  
  const menuItems = getMenuItems();

  return (
    <>
      {/* Mobile Toggle Button */}
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Sidebar Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={toggleSidebar} />}

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src="/letracopagimnasta.png" alt="CopaGimnasta" className="sidebar-logo-img" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />

        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.view}
                className={`nav-item ${view === item.view ? 'active' : ''}`}
                onClick={() => handleNavigate(item.view)}
                style={{
                  '--accent-color': item.color
                }}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        {auth?.role && (
          <div className="sidebar-footer">
            <div className="user-card">
              <div className="user-avatar">
                {auth.user?.name?.[0]?.toUpperCase() || 'U'}
              </div>
              <div className="user-info">
                <p className="user-name">
                  {auth.user?.name || 'Visitante'}
                </p>
                <p className="user-role">
                  {auth.role === 'admin' ? 'Administrador' :
                   auth.role === 'judge' ? 'Juez' : 'Visitante'}
                </p>
              </div>
            </div>
            <button className="logout-btn" onClick={onLogout}>
              <LogOut size={18} />
              <span>Salir</span>
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;
